export default "__VITE_ASSET__BQBDWet9__"